/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InstagramConfirmRequestDto } from '../models/InstagramConfirmRequestDto';
import type { InstagramConfirmResponseDto } from '../models/InstagramConfirmResponseDto';
import type { OAuthStatusesResponseDto } from '../models/OAuthStatusesResponseDto';
import type { ProviderSigninRequestDto } from '../models/ProviderSigninRequestDto';
import type { VerifyOtpResponseDto } from '../models/VerifyOtpResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OAuthService {
    /**
     * Get OAuth status for all providers
     * @returns OAuthStatusesResponseDto
     * @throws ApiError
     */
    public static oAuthControllerGetAllOAuthStatusesV1(): CancelablePromise<OAuthStatusesResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/auth/providers/status',
        });
    }
    /**
     * Confirm the Instagram account connected via the post-OAuth confirm flow
     * @param requestBody
     * @returns InstagramConfirmResponseDto
     * @throws ApiError
     */
    public static oAuthControllerConfirmInstagramAccountV1(
        requestBody: InstagramConfirmRequestDto,
    ): CancelablePromise<InstagramConfirmResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/instagram/confirm',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Initiate OAuth flow for any provider
     * @param provider OAuth provider (google, microsoft, github, etc.)
     * @param token JWT token for authentication (alternative to header)
     * @returns void
     * @throws ApiError
     */
    public static oAuthControllerInitiateOAuthV1(
        provider: string,
        token?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/auth/{provider}',
            path: {
                'provider': provider,
            },
            query: {
                'token': token,
            },
            errors: {
                302: `Redirects to OAuth authorization URL`,
            },
        });
    }
    /**
     * @param provider
     * @param requestBody
     * @returns VerifyOtpResponseDto
     * @throws ApiError
     */
    public static oAuthControllerSigninV1(
        provider: string,
        requestBody: ProviderSigninRequestDto,
    ): CancelablePromise<VerifyOtpResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/{provider}/signin',
            path: {
                'provider': provider,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Handle OAuth callback for any provider
     * @param provider OAuth provider (google, microsoft, github, etc.)
     * @param errorDescription
     * @param errorReason
     * @param code Authorization code from provider
     * @param state State parameter for security
     * @param error Error parameter if OAuth failed
     * @returns any OAuth callback handled successfully
     * @throws ApiError
     */
    public static oAuthControllerHandleOAuthCallbackV1(
        provider: string,
        errorDescription: string,
        errorReason: string,
        code?: string,
        state?: string,
        error?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/auth/{provider}/callback',
            path: {
                'provider': provider,
            },
            query: {
                'code': code,
                'state': state,
                'error': error,
                'error_description': errorDescription,
                'error_reason': errorReason,
            },
        });
    }
    /**
     * Initiate OAuth flow for a specific provider (authenticated)
     * @param provider The OAuth provider (e.g., google, microsoft, github)
     * @param redirectUri OAuth callback redirect URI
     * @returns void
     * @throws ApiError
     */
    public static oAuthControllerGetAuthorizationUrlForProviderV1(
        provider: string,
        redirectUri?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/auth/{provider}/authorize',
            path: {
                'provider': provider,
            },
            query: {
                'redirectUri': redirectUri,
            },
            errors: {
                302: `Redirects to OAuth authorization URL`,
            },
        });
    }
    /**
     * Check OAuth status for a provider
     * @param provider The OAuth provider to check status for
     * @returns any OAuth status retrieved successfully
     * @throws ApiError
     */
    public static oAuthControllerGetOAuthStatusForProviderV1(
        provider: string,
    ): CancelablePromise<{
        isAuthenticated?: boolean;
        email?: string | null;
        provider?: string | null;
        expiresAt?: string | null;
        scopes?: Array<string> | null;
        providerLogo?: string | null;
        isAvailable?: boolean | null;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/auth/{provider}/status',
            path: {
                'provider': provider,
            },
        });
    }
    /**
     * Revoke OAuth credentials for a provider
     * @param provider The OAuth provider to revoke credentials for
     * @returns any Credentials revoked successfully
     * @throws ApiError
     */
    public static oAuthControllerRevokeCredentialsForProviderV1(
        provider: string,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/{provider}/revoke',
            path: {
                'provider': provider,
            },
        });
    }
}
